// input-box.component.ts
import { Component, Input, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '../../shared-services/environment-config.token';

@Component({
  selector: 'app-input-box',
  templateUrl: './input-box.component.html'
})
export class InputBoxComponent {
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() formControl!: FormControl;
  private readonly environmentConfig = inject<EnvironmentConfig | null>(ENVIRONMENT_CONFIG, { optional: true });

  get userInputEnabled(): boolean {
    return this.resolveBooleanFlag(this.environmentConfig?.USER_INPUT_ENABLED) ?? true;
  }

  private resolveBooleanFlag(value: unknown): boolean | null {
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      if (value === 1) return true;
      if (value === 0) return false;
      return null;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      if (['true', '1', 'yes', 'y', 'on'].includes(normalized)) {
        return true;
      }
      if (['false', '0', 'no', 'n', 'off'].includes(normalized)) {
        return false;
      }
    }

    return null;
  }
}
